  <app-header [categoryList]="categoryList"
              *ngIf="!isRestrictedRoute"></app-header>
  <app-sidepull *ngIf="verifySubscription()"></app-sidepull>
  <div class="app-content-body"  [ngClass]="{'app-content-pods': isRestrictedRoute}" *ngIf="!isPageLoader">
    <router-outlet></router-outlet>
  </div>
  <app-footer *ngIf="!isRestrictedRoute"> </app-footer>
